import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './shared/components/TamilRichEditor.css'
import './shared/components/fonts.css'
import './i18n/i18n'
import { Provider } from 'react-redux'
import { store } from './store/store'
import App from './app/App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />

    </Provider>
  </React.StrictMode>
)
